<template>
  <div class="the-header-help-center-footer">
    <div class="the-header-help-center-footer__item">
      <img
        class="the-header-help-center-footer__icon"
        :src="$asset('/cdn/logo-help-color.svg', { source: 'media-hub' })"
        alt="Central de Ajuda"
      >
      <z-text
        class="the-header-help-center-footer__text"
        size="small"
        color="minor"
        tag="span"
        align="left"
      >
        Dúvidas? Acesse nossa
      </z-text>

      <z-link
        class="the-header-help-center-footer__link"
        href="/central-de-ajuda"
      >
        Central de ajuda
      </z-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TheHeaderHelpPopoverFooter',
}
</script>

<style lang="scss" scoped>
.the-header-help-center-footer__item {
  align-items: center;
  column-gap: var(--unit-0200);
  display: grid;
  grid-template-areas: (
    'icon text'
    'icon link'
  );
  grid-template-columns: max-content 1fr;
  grid-template-rows: repeat(2, 1fr);
  text-align: left;

  &:hover {
    cursor: pointer;
  }
}

.the-header-help-center-footer__item--whatsapp {
  margin-top: var(--space-medium);
}

.the-header-help-center-footer__icon {
  grid-area: icon;
  height: var(--unit-0800);
  width: var(--unit-0800);
}

.the-header-help-center-footer__whatsapp-icon {
  background-color: var(--color-green-000);
  border-radius: var(--border-radius-circle);
  grid-area: icon;
  height: var(--unit-0800);
  width: var(--unit-0800);
}

.the-header-help-center-footer__text {
  grid-area: text;
}

.the-header-help-center-footer__link {
  grid-area: link;
}
</style>
